
import DetailsStep from '../vehicle-lookup/steps/DetailsStep.vue';
import HorizontalTextDivider from 'JS/components/HorizontalTextDivider.vue';
import Icon from 'JS/components/Icon.vue';
import SavedVehicle from 'JS/components/automotive/SavedVehicle.vue';
import SavedVehicleMetadata from 'JS/components/automotive/SavedVehicleMetadata.vue';
import Spinner from 'JS/components/Spinner.vue';
import UiButton from 'JS/components/UiButton.vue';
import { computed, defineComponent, nextTick, onMounted, ref, watch } from 'vue';
import { createDetailsStepData } from '../vehicle-lookup/data/steps';
import { ICustomerVehicle, IUpdateVehicleRequest } from 'JS/types/Automotive';
import { PropType } from 'vue';
import { useBreakpoints } from 'JS/composables/breakpoint';

export default defineComponent({
	name: 'VehicleEditor',
	components: {
		DetailsStep,
		UiButton,
		HorizontalTextDivider,
		Icon,
		SavedVehicle,
		SavedVehicleMetadata,
		Spinner,
	},
	props: {
		vehicle: { type: Object as PropType<ICustomerVehicle>, required: true },
		loading: Boolean,
	},
	setup(props, { emit }) {
		const title = ref<HTMLHeadingElement | null>(null);
		const confirmDeletion = ref(false);
		const data = ref({
			...createDetailsStepData(),
			color: props.vehicle.color,
			nickname: props.vehicle.name,
			icon: props.vehicle.iconType,
		});

		const started = ref(false);
		onMounted(() => started.value = true);

		const { isMobile } = useBreakpoints();

		const vehicleLayout = computed(() => {
			if (!confirmDeletion.value) {
				return 'no-icon';
			}

			return isMobile.value ? 'hybrid' : 'horizontal';
		});

		function saveVehicle() {
			const { color, nickname: name, icon: iconType } = data.value;

			const req: IUpdateVehicleRequest = {
				id: props.vehicle.id,
				color,
				name,
				iconType,
			};

			emit('save', req);
		}

		function deleteVehicle() {
			emit('delete');
		}

		watch(confirmDeletion, confirm => {
			if (confirm) {
				nextTick(() => {
					title.value.focus();
				});
			} // step wrapper will receive focus otherwise
		});

		return {
			title,
			confirmDeletion,
			data,
			started,
			vehicleLayout,
			saveVehicle,
			deleteVehicle,
		};
	}
});

// export default VehicleEditor;
